import React, { Component } from 'react';
import { connect } from 'dva';
import { Button, Tag, Modal, message } from 'antd';
import { classNameType } from '../../../../utils/modelData';
import SetBlock from './setBlock';
import styles from './index.less';

@connect(({ homePage }) => ({
  ...homePage,
}))
class PlateSetting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      blockVisible: false,
      selectedBlockIndex: 0, // 当前选中模块的索引
    };
  }

  closeBlockModal = () => {
    this.setState({ blockVisible: false });
  };

  callBack = (tags, selectedRowKeys) => {
    const { selectedBlockIndex } = this.state;
    const { dispatch, formData } = this.props;
    const { modulesData } = formData;
    const modulesDataArr = JSON.parse(JSON.stringify(modulesData));
    modulesDataArr[selectedBlockIndex] = {
      ...modulesDataArr[selectedBlockIndex],
      showNewids: (selectedRowKeys && selectedRowKeys.join(',')) || '',
    };
    modulesDataArr[selectedBlockIndex] = {
      ...modulesDataArr[selectedBlockIndex],
      showNewidsArr: tags,
    };
    dispatch({
      type: 'homePage/saveState',
      payload: {
        formData: {
          ...formData,
          modulesData: modulesDataArr,
          modules: modulesDataArr,
        },
      },
    });
  };

  changeContent = item => {
    const { formData, dispatch } = this.props;
    const { stencilId, modulesData } = formData;
    const { selectedBlockIndex } = this.state;

    const arr = JSON.parse(JSON.stringify(modulesData));
    const params = JSON.parse(JSON.stringify(item));

    if (
      stencilId === 1 ||
      stencilId === 10 ||
      stencilId === 5 ||
      stencilId === 51 ||
      stencilId === 52 ||
      stencilId === 6
    ) {
      if (selectedBlockIndex >= arr.length) {
        arr.push({
          ...params,
          key: modulesData.length + 1,
          sort: modulesData.length + 1,
          fileId: '',
          showNewids: '',
        });
      } else {
        // const data = modulesData[selectedBlockIndex];
        // // 列表模板 一级栏目变化需清空文章
        // if (item.columnurlorkey !== data.columnurlorkey) {
        //   // params.showNewidsArr = [];
        // } else {
        //   // 二级栏目变化 移除不符合的文章
        //   params.showNewidsArr = (item.showNewidsArr || []).filter(ele => {
        //     return item.showSubChannelid && item.showSubChannelid.indexOf(ele.channelId) !== -1;
        //   });
        // }
        arr[selectedBlockIndex] = params;
      }
    } else {
      arr[selectedBlockIndex] = params;
    }

    dispatch({
      type: 'homePage/saveState',
      payload: {
        formData: {
          ...formData,
          modulesData: arr,
          modules: arr,
        },
      },
    });
  };

  selectBlock = index => {
    this.setState({ blockVisible: true, selectedBlockIndex: index });
  };

  // 列表模板 删除
  deleteBlock = () => {
    const { selectedBlockIndex } = this.state;
    const { formData, dispatch } = this.props;
    const { modulesData } = formData;
    const arr = JSON.parse(JSON.stringify(modulesData));
    const that = this;
    Modal.confirm({
      okText: '确认',
      cancelText: '取消',
      title: '您确认要删除这个版块吗？',
      onOk() {
        arr.splice(selectedBlockIndex, 1);
        dispatch({
          type: 'homePage/saveState',
          payload: {
            formData: {
              ...formData,
              modulesData: arr,
              modules: arr,
            },
          },
        });
        message.success('删除成功');
        that.setState({ blockVisible: false });
      },
    });
  };

  resetBlock = () => {
    const { selectedBlockIndex } = this.state;
    const { formData, dispatch } = this.props;
    const { modulesData } = formData;
    const arr = JSON.parse(JSON.stringify(modulesData));
    const that = this;
    const item = arr[selectedBlockIndex];
    arr[selectedBlockIndex] = {
      ...item,
      moduleName: '',
      showNewids: '',
      showSubChannelid: '',
      columnurlorkey: '',
      fileId: '',
      showNewsType: 0,
      showIconType: 0,
    };
    dispatch({
      type: 'homePage/saveState',
      payload: {
        formData: {
          ...formData,
          modulesData: arr,
          modules: arr,
        },
      },
    });
    message.success('删除成功');
    that.setState({ blockVisible: false });
  };

  renderListModel = () => {
    const { formData } = this.props;
    const { modulesData, stencilId } = formData;
    const { length } = modulesData;
    return (
      <div>
        <Button style={{ marginBottom: 16 }} onClick={() => this.selectBlock(length)}>
          添加
        </Button>
        <div className={classNameType[stencilId]}>
          {modulesData.map((item, index) => {
            if (
              (stencilId === 5 && index < 6) ||
              (stencilId === 51 && index < 8) ||
              (stencilId === 52 && index < 4) ||
              (stencilId === 6 && index < 5)
            ) {
              return null;
            }
            return (
              <div className="common" onClick={() => this.selectBlock(index)}>
                {item.moduleName || '设置'}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  renderArticleTag = (showNewidsArr = []) => {
    if (showNewidsArr.length > 0) {
      return showNewidsArr.map(item => <Tag>{item.title}</Tag>);
    }
    return <div style={{ marginBottom: 6 }}>自动显示版块下最新的三篇文章</div>;
  };

  renderOtherModel = () => {
    const { formData } = this.props;
    const { modulesData, stencilId } = formData;
    return (
      <div className={classNameType[stencilId]}>
        {modulesData.map((item, index) => {
          if (
            (stencilId === 5 && index >= 6) ||
            (stencilId === 51 && index >= 8) ||
            (stencilId === 52 && index >= 4) ||
            (stencilId === 6 && index >= 4)
          ) {
            return null;
          }
          return (
            <div className="common" onClick={() => this.selectBlock(index)}>
              {item.moduleName || '设置'}
            </div>
          );
        })}
      </div>
    );
  };

  renderImageModel = () => {
    const { formData } = this.props;
    const { modulesData, stencilId } = formData;
    return (
      <div className={classNameType[stencilId]}>
        {modulesData.map((item, index) => {
          if (stencilId === 6 && index === 4) {
            return (
              <div className="common" onClick={() => this.selectBlock(index)}>
                {item.moduleName || '设置'}
              </div>
            );
          }
          return null;
        })}
      </div>
    );
  };

  render() {
    const { blockVisible, selectedBlockIndex } = this.state;
    const { formData, moduleStyle } = this.props;
    const { stencilId, modulesData } = formData;
    const data = modulesData[selectedBlockIndex] || {};
    const selectNews = data && data.showNewidsArr ? data.showNewidsArr : [];
    return (
      <div className={styles['plate-setting']}>
        {stencilId !== 1 &&
          stencilId !== 10 &&
          stencilId !== 51 &&
          stencilId !== 52 &&
          stencilId !== 5 &&
          stencilId !== 6 &&
          this.renderOtherModel()}
        {(stencilId === 1 || stencilId === 10) && this.renderListModel()}
        {moduleStyle === 'other' &&
          (stencilId === 5 || stencilId === 51 || stencilId === 52 || stencilId === 6) &&
          this.renderOtherModel()}
        {moduleStyle === 'image' && stencilId === 6 && this.renderImageModel()}
        {moduleStyle === 'list' &&
          (stencilId === 5 || stencilId === 51 || stencilId === 52 || stencilId === 6) &&
          this.renderListModel()}

        <SetBlock
          visible={blockVisible}
          close={this.closeBlockModal}
          data={data}
          changeContent={this.changeContent}
          activeModel={stencilId}
          selectNews={selectNews}
          callBack={this.callBack}
          deleteBlock={this.deleteBlock}
          resetBlock={this.resetBlock}
          selectedBlockIndex={selectedBlockIndex}
        />
      </div>
    );
  }
}
export default PlateSetting;
